module.exports = __webpack_public_path__ + "img/UT0421.b81c47a8.png";